const validateName = (name: string) => {
	const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/;
	return regex.test(name);
};

const validatePhone = (phone: string) => {
	const regex = /^[0-9]{0,10}$/;
	return regex.test(phone);
};

const validateEmail = (email: string): boolean => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return email.trim().length > 0 && emailRegex.test(email);
};

export { validateName, validatePhone, validateEmail };
